import React from 'react';
import { RenovationInputs, RenovationService } from '../types/renovation';
import { RENOVATION_RATES, getServiceLabel, getServiceDescription } from '../utils/calculationRates';
import { ServiceToggle } from './ServiceToggle';
import { Translations } from '../types/language';

interface Props {
  inputs: RenovationInputs;
  onChange: (services: Record<string, RenovationService>) => void;
  onCalculate: () => void;
  translations: Translations;
}

export function InputForm({ inputs, onChange, onCalculate, translations }: Props) {
  const handleServiceChange = (
    serviceId: keyof typeof RENOVATION_RATES,
    enabled: boolean,
    area?: number
  ) => {
    const updatedServices = {
      ...inputs.services,
      [serviceId]: {
        ...inputs.services[serviceId],
        id: serviceId,
        enabled,
        area: area ?? inputs.services[serviceId]?.area ?? 0,
      },
    };
    onChange(updatedServices);
  };

  const hasEnabledServices = Object.values(inputs.services).some(service => service.enabled);

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 sm:p-8 md:border-0">
      <h2 className="text-2xl font-bold mb-8 text-center text-gray-800">
        {translations.title}
      </h2>
      <div className="grid gap-4 md:grid-cols-2">
        {Object.entries(RENOVATION_RATES).map(([id]) => (
          <ServiceToggle
            key={id}
            label={getServiceLabel(id as keyof typeof RENOVATION_RATES, translations.language)}
            description={getServiceDescription(id as keyof typeof RENOVATION_RATES, translations.language)}
            enabled={inputs.services[id]?.enabled ?? false}
            onToggle={(enabled) => handleServiceChange(id as keyof typeof RENOVATION_RATES, enabled)}
            area={inputs.services[id]?.area ?? 0}
            onAreaChange={(area) => handleServiceChange(id as keyof typeof RENOVATION_RATES, true, area)}
            areaLabel={translations.area}
            language={translations.language}
          />
        ))}
      </div>
      <button
        onClick={onCalculate}
        disabled={!hasEnabledServices}
        className={`mt-8 w-full py-4 rounded-lg text-white text-lg font-semibold transition-all duration-200 ${
          hasEnabledServices
            ? 'bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-200'
            : 'bg-gray-400 cursor-not-allowed'
        }`}
      >
        {translations.calculate}
      </button>
    </div>
  );
}